import axios from "axios";

const ENV = import.meta.env.REACT_APP_ENV || "production";

// Python API
const AXIOS_REQUEST_CONFIG = {
  development: {
    baseURL: "http://localhost:7072/api",
  },
  production: {
    baseURL: "https://ifuelsmart.azurewebsites.net/api",
    params: {
      code: "6R1QfHKwGzdomXiwjASFBJ7s3l4Ygyljb20KkASLofMkZnUF7dMnHA==",
      clientId: "default",
    },
  },
}[ENV as "development" | "production"];

export const apiAxios = axios.create(AXIOS_REQUEST_CONFIG);

// IFS API (C# Azure Functions)
const IFS_API_AXIOS_REQUEST_CONFIG = {
  development: {
    baseURL: "http://localhost:7071/api",
  },
  production: {
    baseURL: "https://func-prod-ifsapi-w2.azurewebsites.net/api",
    params: {
      code: "h-x69LLBAjmiesV4wQEsjly6NNBbzx0dqJW-8YisV-7cAzFuqHVN5Q==",
    },
  },
}[ENV as "development" | "production"];

export const ifsApi = axios.create(IFS_API_AXIOS_REQUEST_CONFIG);
